module.exports = __webpack_public_path__ + "img/waiting.0712d526.svg";